var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconRefund = function SvgIconRefund(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30 -30)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#454e4f",
    d: "M50.25,43.5h-.024a6.379,6.379,0,0,0-5.768,4H43a1,1,0,0,0,0,2h1.01Q44,49.749,44,50t.01.5H43a1,1,0,0,0,0,2h1.459a6.379,6.379,0,0,0,5.768,4h1.346a1,1,0,0,0,0-2H50.263a4.38,4.38,0,0,1-3.562-2H49a1,1,0,0,0,0-2H46.015A4.355,4.355,0,0,1,46,50.023q0-.023,0-.046a4.355,4.355,0,0,1,.015-.477H50a1,1,0,0,0,0-2H46.7a4.38,4.38,0,0,1,3.562-2h1.309a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454e4f",
    d: "M50,38A12,12,0,1,0,62,50,12,12,0,0,0,50,38ZM40,50A10,10,0,1,1,50,60,10,10,0,0,1,40,50Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98c11d",
    d: "M49,34a1,1,0,0,1,1-1,17,17,0,0,1,0,34,1,1,0,0,1,0-2,15,15,0,0,0,0-30A1,1,0,0,1,49,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98c11d",
    d: "M50.707,31.293a1,1,0,0,1,0,1.414L49.414,34l1.293,1.293a1,1,0,0,1-1.414,1.414l-2-2a1,1,0,0,1,0-1.414l2-2A1,1,0,0,1,50.707,31.293Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRefund, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-refund.bc909cb4.svg";
export { ForwardRef as ReactComponent };